import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const AuthContainer = styled.div`
    background-color: #2c2c2c;
    min-height: 100vh;
    display: flex; /* 这会让 PageContainer 居中 */
    justify-content: center;
    align-items: center;
`;

const AuthLayout = () => {
    return (
        <AuthContainer>
            <Outlet />
        </AuthContainer>
    );
};

export default AuthLayout;

